import React from "react";
import { Header } from "./landing/Header";
import { Footer } from "./landing/Footer";

interface SimulatorShellProps {
  breadcrumb?: string[];
  children: React.ReactNode;
}

const defaultBreadcrumb = ["Homepage", "Match Center"];

export const SimulatorShell: React.FC<SimulatorShellProps> = ({
  breadcrumb = defaultBreadcrumb,
  children,
}) => {
  const breadcrumbItems = breadcrumb.filter(Boolean);
  const handleBackClick = () => {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    window.location.href = "/";
  };

  return (
    <div className="max-h-screen">
      <Header />

      <div className="w-full bg-gray-600 px-5 py-3 text-xs font-semibold uppercase tracking-wide text-white lg:px-10 lg:text-sm 2xl:px-24">
        <nav
          aria-label="Breadcrumb"
          className="flex flex-wrap items-center gap-2"
        >
          <button
            type="button"
            aria-label="Go back"
            onClick={handleBackClick}
            className="mr-1 flex items-center gap-2 rounded-full border border-primary bg-primary/10 px-2 py-1 text-xs font-semibold uppercase tracking-wide text-primary transition hover:border-white hover:text-white hover:bg-primary focus:border-white focus:outline-none focus:ring-2 focus:ring-white/40"
          >
            <svg
              aria-hidden="true"
              className="h-3 w-3 fill-current"
              viewBox="0 0 16 16"
            >
              <path d="M9.85 3.15a.5.5 0 0 1 0 .7L6.71 7l8.29.01a.5.5 0 0 1 0 1H6.71l3.14 3.15a.5.5 0 0 1-.7.7l-4-4a.5.5 0 0 1 0-.7l4-4a.5.5 0 0 1 .7 0Z" />
            </svg>
            <span>Back</span>
          </button>
          {breadcrumbItems.map((item, index) => {
            const isHomepage = index === 0;

            return (
              <React.Fragment key={`${item}-${index}`}>
                {isHomepage ? (
                  <span
                    className="cursor-pointer hover:underline focus:underline"
                    onClick={() => (window.location.href = "/")}
                  >
                    {item}
                  </span>
                ) : (
                  <span>{item}</span>
                )}
                {index < breadcrumbItems.length - 1 && <span>›</span>}
              </React.Fragment>
            );
          })}
        </nav>
      </div>

      <main className="flex flex-col justify-center w-full py-2">
        {children}
      </main>

      <Footer />
    </div>
  );
};
